import { Options, Vue } from 'vue-class-component';

@Options({
	name: 'RadioComponent',
	props: {
		name: String,
		id: String,
		preSelect: { type: String, default: undefined },
		disabled: { type: Boolean, default: false },
		readonly: { type: Boolean, default: false },
		alternateReadonlyPresentation: { type: Boolean, default: false },
		label: String,
		tooltip: String,
		options: Array,
		labels: Array,
		visibleError: Boolean,
		validationErrorText: String,
	},
})
export default class RadioComponent extends Vue {
	name!: string;
	id!: string;
	preSelect?: any;
	disabled?: boolean;
	readonly!: boolean;
	alternateReadonlyPresentation!: boolean;
	change: string = null;
	label: string;
	tooltip: string;
	options: Array<string>;
	labels: Array<string>;
	visibleError: boolean;
	validationErrorText: string;
	readonlyValue: string = null;

	// LIFECYCLE
	public mounted() {
		if (this.preSelect !== undefined) {
			this.options.forEach((option) => {
				if (this.preSelect === option) {
					this.change = option;
				}
			});
		}

		if (this.readonly && this.change) {
			const inx = this.options.indexOf(this.change);
			this.readonlyValue = this.labels[inx];
		}
	}

	// METHODS
	public changeItem(item: string) {
		if (this.alternateReadonlyPresentation) {
			return;
		}
		this.change = item;
		this.emitChange(item);
	}

	public emitChange(item: string) {
		if (this.alternateReadonlyPresentation) {
			return;
		}
		this.$emit('RadioComponent', {
			name: this.name,
			id: this.id + item,
			value: item,
		});
	}

	public get showError() {
		return this.visibleError && !this.change;
	}
}
